import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import React, { useState } from "react";
import TasksList from "modules/tasks/TasksList/TasksList";
import MDButton from "components/MDButton";
import CreateTaskModal from "modules/tasks/CreateTaskModal/CreateTaskModal";

export default function TasksPage() {
  const [status, setStatus] = useState<"open" | "completed">("open");
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} lineHeight={1} display="flex" alignItems="center" width="100%">
                <MDBox>
                  <MDTypography variant="h4" fontWeight="medium">
                    Tasks
                  </MDTypography>
                  <MDTypography variant="caption" color="text">
                    Tasks created by your triggers (and future manual tasks if you add them).
                  </MDTypography>
                </MDBox>

                <MDBox ml="auto" display="flex" alignItems="center" gap={2}>
                  <MDButton variant="gradient" color="success" onClick={() => setCreateOpen(true)}>
                    Add Task
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <CreateTaskModal open={createOpen} onClose={() => setCreateOpen(false)} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TasksList status={status} onStatusChange={setStatus} />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
